var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashButton = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66732 3.15186L3.09774 10.4691C3.18089 11.8827 3.22247 12.5895 3.52417 13.1258C3.78976 13.598 4.19286 13.9781 4.67982 14.2155C5.23299 14.4852 5.94101 14.4852 7.35705 14.4852H8.64426C10.0603 14.4852 10.7683 14.4852 11.3215 14.2155C11.8084 13.9781 12.2115 13.598 12.4771 13.1258C12.7788 12.5895 12.8204 11.8827 12.9036 10.4691L13.334 3.15186M2.66732 3.15186H1.33398M2.66732 3.15186H13.334M13.334 3.15186H14.6673M6.66732 6.48519V11.1519M9.33398 6.48519V9.15186M10.6673 3.15186L10.3653 2.24589C10.2342 1.85248 10.1686 1.65578 10.047 1.51035C9.93961 1.38192 9.80169 1.28252 9.6459 1.22124C9.46947 1.15186 9.26213 1.15186 8.84744 1.15186H7.15387C6.73918 1.15186 6.53183 1.15186 6.3554 1.22124C6.19961 1.28252 6.06169 1.38192 5.9543 1.51035C5.83268 1.65578 5.76711 1.85248 5.63597 2.24589L5.33398 3.15186",
    stroke: "#D12D36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashButton);
export default ForwardRef;